/**
 * Supabase Client Initialization Module
 * Initializes and exports the shared Supabase JavaScript client instance
 * configured with environment variables for database auth, query, and storage operations.
 *
 * SECURITY (VULN-002 fix): No hard-coded credential fallbacks. If the required
 * environment variables are absent the module throws immediately so the problem
 * is caught at build/startup time rather than silently shipping credentials in
 * the bundle. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in
 * your .env.local (development) or deployment environment (production).
 */

import { createClient } from '@supabase/supabase-js';

// Read Supabase configuration strictly from environment variables — no fallbacks.
const supabaseUrl =
  process.env.REACT_APP_SUPABASE_URL ||
  process.env.VITE_SUPABASE_URL;

const supabaseAnonKey =
  process.env.REACT_APP_SUPABASE_ANON_KEY ||
  process.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing required Supabase environment variables. ' +
    'Ensure REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY are set ' +
    'in your .env.local file (development) or deployment environment (production).'
  );
}

// Export singleton Supabase client for app-wide data access and authentication
export const supabase = createClient(supabaseUrl, supabaseAnonKey);